<template>
  <div>
    <el-button type="primary" icon="el-icon-plus" @click="dialogVisible = true"
      >添加</el-button
    >
    <el-dialog
      :visible="dialogVisible"
      title="设置节点"
      width="1000px"
      @close="closeDialog"
    >
      <el-form :model="detail" ref="form" :rules="rules" label-width="100px">
        <el-form-item label="用户ID：" prop="userId">
          <el-input v-model="detail.userId"></el-input>
        </el-form-item>
        <el-form-item label="节点地址：" prop="address">
          <el-input v-model="detail.address"></el-input>
        </el-form-item>
        <!-- <el-form-item label="开启节点：" prop="isNode">
          <el-switch v-model="detail.isNode"></el-switch>
        </el-form-item> -->
        <el-form-item label="节点名字：" prop="nodeName">
          <el-input v-model="detail.nodeName"></el-input>
        </el-form-item>
        <el-form-item label="开启时间：" prop="createTime">
          <el-date-picker
            v-model="detail.createTime"
            type="date"
            placeholder="选择日期时间"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="备注：" prop="description">
          <el-input v-model="detail.description"></el-input>
        </el-form-item>
        <el-form-item label="二维码：" prop="weChatImage">
          <upload v-model="detail.weChatImage" :data="{ platform: 1 }"></upload>
        </el-form-item>
        <el-form-item label="封面图：" prop="bannerImg">
          <upload v-model="detail.bannerImg" :data="{ platform: 1 }"></upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSave()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import Upload from 'components/upload';

export default {
  name: 'setnote',
  data() {
    return {
      dialogVisible: false,
      detail: {},
      rules: {
        nodeName: {
          required: true,
          message: '请填写'
        },
        weChatImage: {
          required: true,
          message: '请填写'
        },
        userId: {
          required: true,
          message: '请填写'
        },
        createTime: {
          required: true,
          message: '请填写'
        },
        address: {
          required: true,
          message: '请填写'
        }
      }
    };
  },
  components: {
    Upload
  },
  computed: {
    ...mapState('setnode', ['pagination', 'records'])
  },
  methods: {
    ...mapActions('setnode', ['setNodes', 'getRecords']),
    closeDialog() {
      this.dialogVisible = false;
      //   this.detail={};
    },
    handleSave() {
      this.setNodes(this.detail)
        .then(() => {
          this.$message({
            message: '开启成功',
            type: 'success'
          });
          this.getRecords({ ...this.pagination, type: 0 });
        })
        .finally(() => {
          this.dialogVisible = false;
        });
    }
  }
};
</script>

<style lang="less" scoped></style>
